<template>
  <svg
    fill="none"
    height="54"
    viewBox="0 0 54 54"
    width="54"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="27"
      cy="27"
      fill="url(#paint0_linear_232_4572)"
      r="27"
    >
      <animate
        :values="animation"
        attributeName="r"
        dur="2.5s"
        fill="freeze"
        repeatCount="indefinite"
      />
    </circle>
    <defs>
      <linearGradient
        id="paint0_linear_232_4572"
        gradientUnits="userSpaceOnUse"
        x1="-1.35"
        x2="56.8764"
        y1="-4.49999"
        y2="7.86277"
      >
        <stop stop-color="#58E2B0" />
        <stop
          offset="1"
          stop-color="#3EB0D3"
        />
      </linearGradient>
    </defs>
  </svg>
</template>

<script lang="ts" setup>
defineProps<{
  animation: {
    type: string
    required: false
  }
}>();
</script>
